import config from '@config';
import MqttService from './MqttService';

export default new MqttService(config.mqttHost, config.mqttFastifyHost);
